import { render, staticRenderFns } from "./Offerte.vue?vue&type=template&id=71eb234c&scoped=true"
import script from "./Offerte.vue?vue&type=script&lang=js"
export * from "./Offerte.vue?vue&type=script&lang=js"
import style0 from "./Offerte.vue?vue&type=style&index=0&id=71eb234c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb234c",
  null
  
)

export default component.exports